import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

// The one shared card primitive. Replaces both @tremor/react's <Card> (which
// every consumer was force-overriding back to a plain div via !important) and
// the ~15 ad-hoc rounded-xl-border-bg div instances scattered across the app.
//
// Padding is fixed at p-4 by default; pass className to override only when the
// component genuinely needs different padding (e.g. compact rows).
export const SectionCard = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function SectionCard({ className, children, ...rest }, ref) {
    return (
      <div
        ref={ref}
        className={cn('rounded-xl border border-zinc-800 bg-zinc-950 p-4', className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);
